import ValueDeserializerInterface from "./ValueDeserializerInterface"
import { SerializedValueType } from "../../Model/Value/ValueInterface"
import GameDeserializer from "../GameDeserializer"
import ProductValue from "../../Model/Value/ProductValue"

export default class ProductValueDeserializer implements ValueDeserializerInterface {
  private serializer: GameDeserializer | undefined = undefined
  public supports(payload: SerializedValueType): boolean {
    return payload.type === "product"
  }

  public deserialize(payload: SerializedValueType): ProductValue {
    if (this.serializer === undefined) {
      throw new Error("Value deserializer is not implemented")
    }

    return new ProductValue(
      this.serializer.deserializeValue(
        payload.payload.left as SerializedValueType,
      ),
      payload.payload.sign,
      this.serializer.deserializeValue(
        payload.payload.right as SerializedValueType,
      ),
    )
  }

  public setSerializer(serializer: GameDeserializer): void {
    this.serializer = serializer
  }
}
